<template>
    <div class="timeline">
        <div :class="'row expedient-status days-between-' + (status.days_difference > '30' ? 30 : status.days_difference)"
             :title="status.days_difference + ' días transcurridos desde el anterior estado.'"
             v-for="(status, index) in statuses" :key="status.id">

            <div class="status-wrapper"
                 :class="(index + 1) === statuses.length ? 'line-up-' + statuses.length : null">
                <v-popover class="btn container-status"
                           title="Observaciones"
                           :content="!!status.extra_data ? status.extra_data : 'No hay observaciones'"
                           :class="status.date ? (isDateBeforeToday(status.date) === true ? 'status-filled-pre' : 'status-filled-post') : null">
                </v-popover>
            </div>

            <div class="status-info">
                <div class="date" v-if="status.date">
                    <span class="badge bg-primary">{{ dateToReadable(status.date) }}</span>
                    <span class="badge bg-secondary"
                          :title="status.days_difference + ' día' + (status.days_difference !== 1 ? 's' : '') + ' transcurrido' + (status.days_difference !== 1 ? 's' : '') + ' desde el anterior estado.'"
                          v-if="index !== 0">
                        {{ status.days_difference }}
                    </span>
                </div>
                <div class="date" v-else>--/--/----</div>
                <div class="status-name">{{ status.display_name }}</div>
            </div>

            <div class="status-actions" v-if="onlyView === false">
                <div class="actions-buttons">
                    <button class="btn btn-show"
                            v-if="can('expedient.status.show')"
                            @click="emit('show-status', status)">
                        <i class="uq-icon bi-eye"></i>
                    </button>

                    <button class="btn btn-edit"
                            v-if="(can('expedient.status.update') && can('expedient.status.update-all')) || index === statuses.length - 1 || (can('expedient.status.update-last') && can('status.use.' + status.name) && status.date === null)"
                            @click="emit('edit-status', status)">
                        <i class="uq-icon bi-pencil"></i>
                    </button>

                    <button class="btn btn-delete"
                            v-if="can('expedient.status.destroy')"
                            @click="emit('delete-status', status)">
                        <i class="uq-icon bi-trash"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {can} from "../../../../helpers/Permissions";
import VPopover from "../../../general/VPopover";

export default {
    name: "VExpedientStatusesTimeline",
    components: {
        VPopover
    },
    props: {
        statuses: {
            type: Object,
            required: true,
        },
        onlyView: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            selected_action: '',
            actionOptions: [],
        }
    },
    setup() {
        return {
            can,
        }
    },
    mounted() {
    },
    methods: {
        dateToReadable(date) {
            let splitted = date.substr(0, 10).split('-');
            return splitted[2] + '/' + splitted[1] + '/' + splitted[0];
        },
        isDateBeforeToday(date) {
            return new Date(date).getTime() < new Date().getTime();
        },
        emit(event, data) {
            this.$emit(event, data);
        },
        closeModal() {
            this.$emit('closed');
        }
    },
}
</script>
